import $ from 'jquery'

function init () {
  $('.play-btn').each(function () {
    let target = $(this).attr('data-target')
    $(this).on('click', () => $(target).modal())
  })
}

export default {
  init
}
